const $ = jQuery;

class TOC {
	constructor() {
		this.initMicroModal();
		if (null === document.querySelector('.toc')) {
			return;
		}

		this.links = document.querySelectorAll('.toc__link');
		this.topBar = document.querySelector('.single-wrapper__top-bar');
		this.headerOffset = this.getHeaderOffset();
		this.breakpoints = this.getBreakpoints();
		this.currentBreakpoint = this.breakpoints[0];
		this.links[0].parentElement.classList.add('active');
		this.links[0].setAttribute('aria-current', 'true');

		this.setTopBarHeight();
		window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
		window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
	}

	handleResize() {
		this.setTopBarHeight();
		this.headerOffset = this.getHeaderOffset();
		this.breakpoints = this.getBreakpoints();
	}

	getHeaderOffset() {
		const headerHeight = getComputedStyle(document.documentElement).getPropertyValue(
			'--headerHeightFull'
		);

		return (this.headerOffset = this.topBar.offsetHeight + +headerHeight.replace('px', ''));
	}

	setTopBarHeight() {
		if (null !== this.topBar) {
			document.documentElement.style.setProperty(
				'--topBarHeight',
				this.topBar.offsetHeight + 'px'
			);
		}
	}

	handleScroll() {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

		let newBreakpoint;
		this.breakpoints.forEach((breakpoint) => {
			if (scrollTop >= breakpoint.offset) {
				newBreakpoint = breakpoint;
			}
		});

		if (newBreakpoint.href !== this.currentBreakpoint.href) {
			this.currentBreakpoint = newBreakpoint;
			this.links.forEach((link) => {
				link.parentElement.classList.remove('active');
				link.setAttribute('aria-current', 'false');
			});

			const target = document.querySelector(`[href="${newBreakpoint.href}"]`);
			if (null !== target) {
				target.parentElement.classList.add('active');
				target.setAttribute('aria-current', 'true');
			}
		}
	}

	getBreakpoints() {
		const breakpoints = [];
		this.links.forEach((link) => {
			const target = document.querySelector(link.getAttribute('href'));

			if (null !== target) {
				breakpoints.push({
					offset: breakpoints.length
						? Math.round($(target).offset().top) - this.headerOffset
						: 0,
					href: link.getAttribute('href'),
				});
			}
		});

		return breakpoints;
	}

	initMicroModal() {
		// eslint-disable-next-line no-undef
		MicroModal.init({
			disableScroll: true,
			openTrigger: 'data-subscribe-open',
			awaitCloseAnimation: true,
		});
	}
}

new TOC();
